import { ReactNode } from 'react';

import { ColorPalette, IconProps } from '@lumapps/lumx/react';
import { SearchSuggestion } from '@lumapps/search/types';
import { WithRequiredProperty } from '@lumapps/utils/types/WithRequiredProperty';

type SearchSuggestionWithItem = WithRequiredProperty<SearchSuggestion, 'item'>;

/** Custom options for history icon */
export interface HistoryIconOptions {
    /** Custom icon for history items */
    icon?: IconProps['icon'];
    /** Whether the history icon should have a shape */
    hasShape?: boolean;
    /** Color of the history icon */
    color?: ColorPalette;
}

/** Props for the SearchBoxOption component */
export interface SearchBoxOptionProps {
    id: string;
    className?: string;
    suggestion: SearchSuggestion;
    onSelect: (suggestion: SearchSuggestion) => void;
    after?: ReactNode;
    query?: string;
    /** Custom options for history icon */
    historyOptions?: HistoryIconOptions;
}

/** Props for each search box option types components (interaction, users, etc...) */
export interface SearchBoxOptionTypeProps extends SearchBoxOptionProps {
    onSelect: () => void;
}

export type SearchBoxOptionWithItemProps = SearchBoxOptionTypeProps & { suggestion: SearchSuggestionWithItem };

/** Checks if the current suggestion has an item */
export const isSuggestionWithItem = (suggestion: SearchSuggestion): suggestion is SearchSuggestionWithItem =>
    Boolean(suggestion.item);
